import React, { useEffect, useState } from "react";
import InfoSection from "./InfoSection ";
import WhyChooseGlap from "./WhyChooseGlap";
import VirtualOfficeSection from "./VirtualOfficeSection";
import StudentStory from "./StudentStory";
// import VisaCategory from "./VisaCategory";
// import OurDestination from "./OurDestination";
import Helpbanner from "./HelpBanner";
import BlogSection from "./BlogSection";
import HeroSection from "../../components/common/HeroSection";
import CountryHighlights from "../../components/common/CountryHighlights";
import AboutSection from "../../components/common/AboutSection";
import WhatsApp from "../../assets/whatsapp.png";
import { getHomePage } from "../../services/HomePageService";
import { useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import { useHomeData } from "../../context/HomeDataContext";
import { Skeleton } from "@mui/material";
import {
  Grid,
  Stack,
  Container,
  useMediaQuery,
  useTheme,
  Typography,
} from "@mui/material";

const Home = () => {
  const { country_id, country_name } = useSelector((state) => state.auth || {});
  const { homeData, loading } = useHomeData();
  // const [loading, setLoading] = useState(true);
  // const [homeData, setHomeData] = useState(null);
  // const [highlightsEnabled, setHighlightsEnabled] = useState(true);

  // useEffect(() => {
  //   if (!country_id) return; // Wait until Redux has loaded country_id
  //   setLoading(true);

  //   const fetchHomeData = async () => {
  //     try {
  //       const res = await getHomePage();
  //       if (res?.data?.success && res?.data?.data) {
  //         setHomeData(res.data.data);

  //         // const highlightsEnabledRaw = 
  //         //   res.data.data.highlights_enabled !== undefined 
  //         //     ? res.data.data.highlights_enabled 
  //         //     : res.data.data.highlightsEnabled;

  //         // // Default to true for backward compatibility if field is missing
  //         // let highlightsEnabledValue = true;

  //         // if (highlightsEnabledRaw !== undefined && highlightsEnabledRaw !== null) {
  //         //   // Handle boolean
  //         //   if (typeof highlightsEnabledRaw === "boolean") {
  //         //     highlightsEnabledValue = highlightsEnabledRaw;
  //         //   }
  //         //   // Handle string "true"/"false"
  //         //   else if (typeof highlightsEnabledRaw === "string") {
  //         //     highlightsEnabledValue = highlightsEnabledRaw.toLowerCase() === "true";
  //         //   }
  //         //   // Handle number 0/1
  //         //   else if (typeof highlightsEnabledRaw === "number") {
  //         //     highlightsEnabledValue = highlightsEnabledRaw === 1;
  //         //   }
  //         // }

  //         // setHighlightsEnabled(highlightsEnabledValue);
  //       } else {
  //         setHomeData(null);
  //       }
  //     } catch (err) {
  //       console.error("❌ Error fetching Home page:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchHomeData();
  // }, []);

  if (loading) {
    return (
      <Container
        sx={{
          py: { xs: 3, sm: 4, md: 6 },
          px: { xs: 3, sm: 4, md: 6 },
        }}
      >
        <Grid container spacing={2} alignItems="center">

          {/* Left skeleton */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton variant="text" height={60} width="80%" />
            <Skeleton variant="text" height={30} width="90%" />
            <Skeleton variant="text" height={30} width="85%" />

            <Stack direction="row" spacing={2} mt={3}>
              <Skeleton variant="rounded" width={140} height={45} />
              <Skeleton variant="rounded" width={140} height={45} />
            </Stack>

            <Stack spacing={2} mt={3}>
              <Skeleton variant="text" width="70%" />
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="75%" />
            </Stack>
          </Grid>

          {/* Right skeleton */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton
              variant="rectangular"
              height={420}
              sx={{ borderRadius: 2 }}
            />
          </Grid>

        </Grid>
      </Container>
    );
  }

  // if (loading)
  //   return (
  //     <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
  //       <CircularProgress color="warning" />
  //     </Box>
  //   );

  if (!homeData)
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <p>No homepage data found for {country_name || "selected country"}.</p>
      </Box>
    );

  // ✅ Extract data safely from API response
  const heroTitle = homeData.hero_section_title || "";
  const heroSubtitle = homeData.hero_section_desc || "";
  const heroImage = homeData.hero_section_image || "";
  const heroImageType = homeData.hero_section_image_type || "";
  const infoTitle = homeData.infotitle || "";
  const desc = homeData.desc || "";
  const desc_section_image = homeData.desc_section_image || null;
  const desc_section_image_type = homeData.desc_section_image_type || "image";
  const how_use_title = homeData.how_use_title || "";
  const how_use_desc = homeData.how_use_desc || "";
  const how_use_section_image = homeData.how_use_section_image || null;
  const how_use_section_image_type = homeData.how_use_section_image_type || "image";
  const highlights =
    homeData.highlights?.map((item) => ({
      title: item.key,
      subtitle: item.value,
    })) || [];

  const aboutTitle = homeData.about_title;
  const aboutDesc = homeData.about_desc || "";
  const aboutImage = homeData.about_section_image || "";
  const buttonDesc = homeData.button_desc || "";
  const aboutPoints = [
    "Here to Assist Your Immigration Journey!",
    "Efficient Solutions at Affordable Price!",
  ];

  return (
    <>
      {/* 🟠 Hero Section */}
      <HeroSection
        titleContent={heroTitle}
        subtitleContent={heroSubtitle}
        buttons={[
          { label: "Book Free Guidance", link: "#bookfreeguidance", },
          {
            label: "Whatsapp",
            link: "whatsapp",
            icon: (
              <img
                src={WhatsApp}
                alt="whatsapp"
                style={{ width: 24, height: 24 }}
              />
            ),
          },
        ]}
        buttonsDesc={buttonDesc}
        heroImage={heroImage}
        heroImageType={heroImageType}
      />

      {/* 
      {highlightsEnabled === true && highlights.length > 0 && (
        <CountryHighlights stats={highlights} />
      )}
      */}

      {/* 🟠 Info + About */}
      <InfoSection
        title={infoTitle}
        desc={desc}
        desc_section_image={desc_section_image}
        desc_section_image_type={desc_section_image_type}
        how_use_title={how_use_title}
        how_use_desc={how_use_desc}
        how_use_section_image={how_use_section_image}
        how_use_section_image_type={how_use_section_image_type}
      />

      <AboutSection
        title={aboutTitle}
        desc={aboutDesc}
        mediaType={homeData.about_section_image_type || "image"}
        // points={aboutPoints}
        mediaLink={aboutImage}
      />

      {/* 🟠 Remaining Sections */}
      <WhyChooseGlap title={homeData.why_choose_title} desc={homeData.why_choose_desc} features={homeData.features} />
      {/* <StudentStory /> */}
      {/* <VisaCategory /> */}
      {/* <OurDestination /> */}
      <Helpbanner tollfreenumber={homeData.tollfreenumber} />
      {/* <BlogSection /> */}
    </>
  );
};

export default Home;
